export { RegisteredComponentBuilder } from './registered-component-builder'
